/* eslint-disable */
export const printANSI = () => {
  // console.clear()
  console.log('[RuoYi-Antdv] created()')
  console.log('POWERED BY RuoYi-Vue. Antd-Vue. Antd-Vue-Pro')
  // ASCII - ANSI Shadow
  let text = "jetcloud"
  console.log(`%c${text}`, 'color: #fc4d50')
}
